<template>
    <v-card variant="flat" class="px-4 pt-3" style="border-radius: 16px;">
        <v-form ref="form" @submit.prevent="save">
            <v-row>
                <v-col class="px-4 mt-2" cols="12">
                    <div class="d-flex"
                        style="justify-content: space-between !important; align-items: center !important;">
                        <div>
                            <h2 class="main_title">
                               {{ viewType == 'edit'?'Edit': viewType == 'view'?'View':"" }} <span style=" color: rgb(8, 47, 177);">{{designation}}</span> 
                                </h2>
                        </div>
                        <span @click="$emit('close')"  class="mdi mdi-close"></span>
                    </div>
                </v-col>
            </v-row>

            <v-card-text>
                <v-row class="pa-0 mt-2">
                    <v-col cols="12" class="px-0 py-0 d-flex align-center justify-center">
                        <v-radio-group
                          :disabled="viewType === 'view'"
                          v-model="formData.active"
                          inline
                        >
                          <v-radio color="primary" label="Active" :value="1"></v-radio>
                          <v-radio color="error" label="Inactive" :value="0"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="4" class="py-0 px-1">
                        <v-label>Customer <span style="color: red;">*</span></v-label>
                        
                        <TextFieldComponent :rules="getRules('Customer')" placeholder="Customer" :disabled="viewType === 'view'"
                            v-model="formData.customer" />
                    </v-col>
                    <v-col cols="4" class="py-0 px-1">
                        <v-label>Name <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Name')" placeholder="Name" :disabled="viewType === 'view'" v-model="formData.name" />
                    </v-col>
                    <!-- <v-col cols="4" class="py-0 px-1">
                        <v-label>Alert</v-label>
                        <TextFieldComponent placeholder="Alert" :disabled="viewType === 'view'" v-model="formData.alert" />
                    </v-col> -->
                    <v-col cols="4" class="py-0 px-1">
                        <v-label>Factor <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Factor')" placeholder="Factor" :disabled="viewType === 'view'" v-model="formData.factor" />
                    </v-col>
                    <v-col cols="4" class="py-0 px-1">
                        <v-label>EDI <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('EDI')" placeholder="EDI" :disabled="viewType === 'view'" v-model="formData.edi" />
                    </v-col>
                    <v-col cols="4" class="py-0 px-1">
                        <v-label>UCC Labels <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('UCC Labels')" placeholder="UCC Labels" :disabled="viewType === 'view'"
                            v-model="formData.ucc_labels" />
                    </v-col>

                    <v-col cols="4" class="py-0 px-1">
                        <v-label>ASN <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('ASN')" placeholder="ASN" :disabled="viewType === 'view'" v-model="formData.asn" />
                    </v-col>

                    <v-col cols="4" class="py-0 px-1">
                        <v-label>Substitution <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Substitution')" placeholder="Substitution" :disabled="viewType === 'view'" v-model="formData.substitution" />
                    </v-col>

                    <v-col cols="4" class="py-0 px-1">
                        <v-label>Off Pack <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Off Pack')" placeholder="Off Pack" :disabled="viewType === 'view'" v-model="formData.off_pack" />
                    </v-col>

                    <v-col cols="4" class="py-0 px-1">
                        <v-label>Customer Type <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Customer Type')" placeholder="Customer Type" :disabled="viewType === 'view'" v-model="formData.customer_type" />
                    </v-col>

                    <v-col cols="4" class="py-0 px-1">
                        <v-label>Direct Customer <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Direct Customer')" placeholder="Direct Customer" :disabled="viewType === 'view'" v-model="formData.direct_customer" />
                    </v-col>

                    <v-col cols="4" class="py-0 px-1">
                        <v-label>855 <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('855')" placeholder="855" :disabled="viewType === 'view'" v-model="formData.c855" />
                    </v-col>

                    <v-col cols="4" class="py-0 px-1">
                        <v-label>940 & 997 <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('940 & 997')" placeholder="855" :disabled="viewType === 'view'" v-model="formData.c940997" />
                    </v-col>

                      <v-col cols="12" class="py-0 px-1">
                        <v-label>Alert <span style="color: red;">*</span></v-label>
                        <v-textarea :rules="getRules('Alert')" variant="outlined" placeholder="Alert" :disabled="viewType === 'view'" v-model="formData.alert"> </v-textarea>
                    </v-col>

                    <v-col cols="12" class="py-0 px-1">
                        <v-label>Courses Of Action <span style="color: red;">*</span></v-label>
                        <v-textarea :rules="getRules('Courses Of Action')" variant="outlined"  placeholder="Courses Of Action" :disabled="viewType === 'view'" v-model="formData.courses_of_action"></v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-col cols="12" align="end" v-if="viewType === 'edit'">
                <v-btn @click="$emit('close')" class="cancel mr-3" color="gray">
                    Cancel
                </v-btn>
                <v-btn type="submit" class="save" color="rgb(8, 47, 177)">Save</v-btn>
            </v-col>
        </v-form>
    </v-card>
</template>

<script>
// import AutoComplete from "@/components/ui/AutoComplete.vue";
import TextFieldComponent from "@/components/TextFieldComponent.vue";

export default {
    components: {
        // AutoComplete,
        TextFieldComponent,
    },
    data: () => ({
        formData: {
            customer:null,
            name:null,
            alert:null,
            factor:null,
            edi:null,
            ucc_labels:null,
            asn:null,
            substitution:null,
            off_pack:null,
            customer_type:null,
            direct_customer:null,
            c855:null,
            c940997:null,
            courses_of_action:null,
            active:null,
            created:null,
            created_by:null,
            deleted:null,
            deleted_by:null,
        },
    }),
    props:['designation','customerForm','viewType','index'],
    created(){
        console.log(this.customerForm,"customerForm!!!!")
            this.formData.customer = this.customerForm.customer,
            this.formData.name = this.customerForm.name,
            this.formData.alert = this.customerForm.alert,
            this.formData.factor = this.customerForm.factor,
            this.formData.edi = this.customerForm.edi,
            this.formData.ucc_labels = this.customerForm.ucc_labels,
            this.formData.asn = this.customerForm.asn,
            this.formData.substitution = this.customerForm.substitution,
            this.formData.off_pack = this.customerForm.off_pack,
            this.formData.customer_type = this.customerForm.customer_type,
            this.formData.direct_customer = this.customerForm.direct_customer,
            this.formData.c855 = this.customerForm.c855,
            this.formData.c940997 = this.customerForm.c940997,
            this.formData.courses_of_action = this.customerForm.courses_of_action
            this.formData.active = this.customerForm.active
            this.formData.created = this.customerForm.created
            this.formData.created_by = this.customerForm.created_by
            this.formData.deleted = this.customerForm.deleted
            this.formData.deleted_by = this.customerForm.deleted_by
            this.formData.id = this.customerForm.id
        console.log(this.formData,'this.@@@')
    },
    
    methods:{
        getRules(name) {
            if (name && name.toLowerCase() === "email") {
                return [
                    (v) => !!v || "E-mail is required.",
                    (v) => /.+@.+\..+/.test(v) || "E-mail must be valid.",
                ];
            }
            return [(v) => !!v || `${name} is required.`];
        },
        async save() {
            const validation = await this.$refs.form.validate();
            if (!validation.valid) {
                console.log("Form not valid");
            } else {
                if(this.viewType == "edit"){
                this.$emit("update-location",this.formData,this.index,this.viewType)
                }
                // else{
                // this.$emit("save", this.formData,this.designation);
                // }
                this.formData = {};
                this.$emit("close");
            } 
        },
    },
}

</script>

<style scoped>
.v-label {
    margin-bottom: 3px;
    font-size: 14px;
    opacity: 1;
    font-weight: 600;
}

.main_title {
    font-size: 16px;
    font-weight: 600;
}

.v-btn-toggle .v-btn {
    background-color: #E9DFFF;

}

.v-btn-toggle {
    height: 32px !important;
}
</style>